export default "__VITE_ASSET__Wu3IcoSV__"